import httpClient from 'http-client';
import Product from './models/product-interface';

const getAllProducts = async (filters?: object): Promise<Product[]> => {
  const product: Product[] = (
    await httpClient.get('/products', {
      params: filters,
    })
  ).data;
  const ordem = ['Regenesis Pré', 'Regenesis', 'Regenesis Premium'];
  const orderedProducts = product.sort((a, b) => {
    return ordem.indexOf(a.title) - ordem.indexOf(b.title);
  });
  return orderedProducts;
};

const getProduct = async (productId: string): Promise<Product> => {
  const product = (await httpClient.get(`/products/${productId}`)).data;

  return product;
};

export { getProduct, getAllProducts };
